import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
// @mui
import { Box, Card, CardHeader, Typography, IconButton } from '@mui/material';
import { FileDownloadOutlined } from '@mui/icons-material'; // Import download icon
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { BaseOptionChart } from '../../../components/chart';

// ----------------------------------------------------------------------

AppConversionRates.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
};

export default function AppConversionRates({ title, subheader, chartData }) {
  
  // Ensure chartData is not empty
  if (!chartData || chartData.length === 0) {
    return (
      <Card>
        <CardHeader title={title} subheader={subheader} />
        <Box sx={{ mx: 3 }} dir="ltr">
          <Typography variant="body2">No data available</Typography>
        </Box>
      </Card>
    );
  }

  const chartLabels = chartData.map((i) => i.label);
  const chartSeries = [{ name: 'Count', data: chartData.map((i) => i.value) }];

  const chartOptions = merge(BaseOptionChart(), {
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: () => '',
        },
      },
    },
    plotOptions: {
      bar: { horizontal: true, barHeight: '28%', borderRadius: 2 },
    },
    xaxis: {
      categories: chartLabels,
    },
    chart: {
      id: 'bar-chart', // Set an ID for the chart
    }
  });

  const handleDownload = () => {
    // Use ApexCharts to download the image
    ApexCharts.exec('bar-chart', 'dataURI').then(({ imgURI }) => {
      const link = document.createElement('a');
      link.href = imgURI; // Set the href to the image URI
      link.download = 'chart.png'; // Set the desired file name
      document.body.appendChild(link); // Append to body
      link.click(); // Trigger download
      document.body.removeChild(link); // Remove link after download
    }).catch((error) => {
      console.error("Error during download:", error);
      alert("Failed to download image.");
    });
  };

  return (
    <Card>
      <CardHeader 
        title={title} 
        subheader={subheader} 
        action={
          <IconButton onClick={handleDownload}>
            <FileDownloadOutlined />
          </IconButton>
        }
      />

      <Box sx={{ mx: 3 }} dir="ltr">
        <ReactApexChart type="bar" series={chartSeries} options={chartOptions} height={395} width="100%" />
      </Box>
    </Card>
  );
}
